<nav aria-label="breadcrumb">
  <ol class="breadcrumb">
    <li class="breadcrumb-item active" aria-current="page">
      <a [routerLink]="'/configuration/goals'">Goals</a>
    </li>
    <li class="breadcrumb-item" aria-current="page">
      @if (isCreate()) {
        <span class="fs-5 fw-bold mb-0">Add goal</span>
      }
      @if (!isCreate()) {
        <span class="fs-5 fw-bold mb-0">Edit goal</span>
      }
    </li>
  </ol>
</nav>

<div class="card border-0 shadow mb-3 fade-in-zoom">
  <div class="card-body">
    <form [formGroup]="form" (ngSubmit)="onSubmit()">
      <div class="row g-3 mb-3">
        <div class="col-6">
          <label for="goalName" class="form-label">Name</label>
          <div class="input-group">
            <span class="input-group-text"><i class="bi bi-tag"></i></span>
            <input type="text" class="form-control" id="goalName" placeholder="Enter goal name"
              formControlName="name">
          </div>
        </div>
        <div class="col-6">
          <label for="identifier" class="form-label">API Identifier</label>
          <div class="input-group">
            <span class="input-group-text"><i class="bi bi-tag"></i></span>
            <input type="text" class="form-control" id="identifier" placeholder="Enter API identifier"
              formControlName="identifier">
          </div>
        </div>
      </div>
      <div class="row g-3 mb-3">
        <div class="col-6">
          <label for="addToRevenue" class="form-label">Add to revenue</label>
          <app-input-switch formControlName="addToRevenue" id="addToRevenue"></app-input-switch>
        </div>
      </div>

      <h2 class="fs-6 fw-bold mt-5">Goal types ({{ getTypeCount() }})</h2>
      <table class="table mb-5">
        <thead>
          <tr>
            <th>Name</th>
            <th>API Identifier</th>
            <th class="text-end">
              <button class="btn btn-sm btn-primary" type="button" (click)="addType()"><i class="bi bi-plus-lg"></i>
            </button>
          </th>
        </tr>
      </thead>
      <tbody>
        @for (type of goal?.types; track type) {
          <tr>
            <td>
              <input type="text" class="form-control" [(ngModel)]="type.name" [ngModelOptions]="{standalone: true}"
                (ngModelChange)="updateType(type)">
            </td>
            <td>
              <input type="text" class="form-control" [(ngModel)]="type.identifier" [ngModelOptions]="{standalone: true}"
                (ngModelChange)="updateType(type)">
            </td>
            <td class="text-end">
              <button class="btn btn-sm btn-danger" type="button" appConfirm (click)="deleteType(type)"><i
              class="bi bi-trash"></i></button>
            </td>
          </tr>
        }
      </tbody>
    </table>

    <div class="col-12 text-end">
      <button type="submit" class="btn btn-primary fw-bold" [disabled]="!canUpdate()">
        @if (isCreate()) {
          <span>Create</span>
        }
        @if (!isCreate()) {
          <span>Update</span>
        }
      </button>
    </div>
  </form>
</div>
</div>
